import React, { useCallback } from 'react';
import { createSelector } from 'reselect';
import { useSelector, useDispatch } from 'react-redux';
import Global from '../store/global-selectors';
import * as Actions from '../store/orders/filtering/orders.filtering.actions';
import { SaveFilterViewModal } from '../components/modals/save-filterview-modal';
import { useModalContext } from 'ui-components/components/modal/context';
import { useSelectedOrdersViewId } from '../pages/orders-page/orders-left-nav/orders-left-nav-context';

const savedFilterViewsSelector = createSelector(
  (savedFilterViews) => savedFilterViews,
  (_, viewId) => viewId,
  (savedFilterViews, viewId) => {
    return savedFilterViews.filter((view) => view.gridViewId === viewId);
  },
);

export const SaveOrdersFilterviewModalContainer = React.memo(() => {
  const { onClose } = useModalContext();
  const dispatch = useDispatch();
  const savedFilterViews = useSelector(Global.selectOrdersFilteringSavedFilterViews);
  const currentGridViewId = useSelectedOrdersViewId();
  const customFilterView = useSelector(Global.selectOrdersFilteringCustomFilterView);
  const savedFilterViewsForCurrentView = savedFilterViewsSelector(savedFilterViews, currentGridViewId);

  const saveNewFilterViewRequest = useCallback(
    (newFilterView) => {
      dispatch(Actions.saveNewFilterViewRequest(newFilterView));
      onClose();
    },
    [onClose, dispatch],
  );
  const saveExistingFilterViewRequest = useCallback(
    (viewWithNewFilters) => {
      dispatch(Actions.saveExistingFilterViewRequest(viewWithNewFilters));
      onClose();
    },
    [onClose, dispatch],
  );

  return (
    <SaveFilterViewModal
      currentGridViewId={currentGridViewId}
      customFilterView={customFilterView}
      savedFilterViews={savedFilterViewsForCurrentView}
      saveExistingFilterViewRequest={saveExistingFilterViewRequest}
      saveNewFilterViewRequest={saveNewFilterViewRequest}
    />
  );
});
